import { createSlice } from '@reduxjs/toolkit';

interface FloorPlanState {
	openSidebar: boolean;
}

const initialState: FloorPlanState = {
	openSidebar: false,
};

const floorPlanSlice = createSlice({
	name: 'floorPlan',
	initialState,
	reducers: {
		setSidebarOpen: (state) => {
			state.openSidebar = !state.openSidebar;
		},
	},
});

export const { setSidebarOpen } = floorPlanSlice.actions;

export const selectOpenSidebar = (state: { venue: { floorPlan: FloorPlanState } }) => state.venue.floorPlan.openSidebar;

export default floorPlanSlice.reducer;
